import Vue from 'vue'
import UserbackPlugin from '@userback/vue2'
if (process.env.USERBACK_TOKEN) {
  Vue.use(UserbackPlugin, { token: process.env.USERBACK_TOKEN })
}
